/**
 * Classic N: a zigzag of shelves (docs/spec/03 §2). The way down runs back and forth through gaps
 * at alternate ends, and a heap of boulders beside every gap pours down after whoever goes through.
 */

import type { CaveDef } from '../types';

export const caveN: CaveDef = {
  id: 'N',
  name: 'SWITCHBACK',
  hint: 'Every way down has a heap waiting to follow you.',
  intermission: false,
  colors: [6, 12, 7],
  diamondValue: 25,
  extraValue: 40,
  fill: { base: '.', items: [['r', 8], ['d', 8]] },
  levels: [
    { seed: 2701, diamonds: 16, time: 120 },
    { seed: 2702, diamonds: 18, time: 110 },
    { seed: 2703, diamonds: 20, time: 100 },
    { seed: 2704, diamonds: 22, time: 95 },
    { seed: 2705, diamonds: 24, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???????????????????????????????????W',
    'W.P.??????????????????????????.........W',
    'W...????????????d.d?????????????rr.....W',
    'W??????????????????????????????rrr.....W',
    'Wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww.....W',
    'W.........?????????????????????????????W',
    'W.....rr????????????d.d.d??????????????W',
    'W.....rrr??????????????????????????????W',
    'W.....wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwW',
    'W?????????????????????????????.........W',
    'W???????????dd??????????????????rr.....W',
    'W??????????????????????????????rrr.....W',
    'Wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww.....W',
    'W.........?????????????????????????????W',
    'W.....rr????????????????d.d????????????W',
    'W.....rrr??????????????????????????????W',
    'W.....wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwW',
    'W??????????????????????????????????????W',
    'W???????????????????ddd????????????????W',
    'W????????????????????????????????????X?W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
